import { PRICE_LIST_SEIMEI_COURSE } from "@/pricelist/seimei-course";
import { PRICE_LIST_SEIKATSU_MEDICAL } from "@/pricelist/seikatsu-medical";
import { PRICE_LIST_SEIKATSU_CANCER } from "./seikatsu-cancer";
import { PRICE_LIST_SEIKATSU_NURSING } from "./seikatsu-nursing";
import { PRICE_LIST_SEIKATSU_INJURY } from "./seikatsu-injury";
import { PRICE_LIST_SEIKATSU_COMPENSATION } from "./seikatsu-compensation";
import { PRICE_LIST_SHUSHIN_COURSE } from "@/pricelist/shushin-course";
import { PRICE_LIST_TSUMITATE_COURSE_A } from "./tsumitate-course-a";
import { PRICE_LIST_TSUMITATE_COURSE_B } from "./tsumitate-course-b";
const PRICE_LIST = [
  PRICE_LIST_SEIMEI_COURSE,
  PRICE_LIST_SEIKATSU_MEDICAL,
  PRICE_LIST_SEIKATSU_CANCER,
  PRICE_LIST_SEIKATSU_NURSING,
  PRICE_LIST_SEIKATSU_INJURY,
  PRICE_LIST_SEIKATSU_COMPENSATION,
  PRICE_LIST_SHUSHIN_COURSE,
  PRICE_LIST_TSUMITATE_COURSE_A,
  PRICE_LIST_TSUMITATE_COURSE_B,
];
export { PRICE_LIST };
